import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import * as i3 from 'primeng/tooltip';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class MarkInOutService {
    constructor(http) {
        this.http = http;
    }
    /**
     * Get Mark in and Mark out Details
     * @returns
     */
    getAttendanceMarkedDetailsToday(employeeId, dateTime) {
        return this.http.get(`/vd/formBuilder/employee/${employeeId}/attendanceMarkedDetails/today/${dateTime}`);
    }
    /**
     * Mark In Attendance
     * @returns
     */
    markInAttendance(dateTime) {
        return this.http.post(`/vd/formBuilder/employee/attendance/MARKED_IN/${dateTime}`, null);
    }
    /**
     * Mark Out Attendance
     * @returns
     */
    markOutAttendance(dateTime) {
        return this.http.post(`/vd/formBuilder/employee/attendance/MARKED_OUT/${dateTime}`, null);
    }
}
MarkInOutService.ɵfac = function MarkInOutService_Factory(t) { return new (t || MarkInOutService)(i0.ɵɵinject(i1.HttpClient)); };
MarkInOutService.ɵprov = i0.ɵɵdefineInjectable({ token: MarkInOutService, factory: MarkInOutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MarkInOutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function MarkInOutComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3, "Let's get to work");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵlistener("click", function MarkInOutComponent_div_2_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.markIn(); });
    i0.ɵɵelement(6, "i", 8);
    i0.ɵɵtext(7, " Mark in ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MarkInOutComponent_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1, "Marked in at ");
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.time);
} }
const _c0 = function (a0) { return { "paddingTopBottom0": a0 }; };
function MarkInOutComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Done for the day?");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MarkInOutComponent_div_3_span_4_Template, 4, 1, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "button", 7);
    i0.ɵɵlistener("click", function MarkInOutComponent_div_3_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.markOut(); });
    i0.ɵɵelement(7, "i", 11);
    i0.ɵɵtext(8, " Mark out ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, !!ctx_r1.time));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !!ctx_r1.time);
} }
class MarkInOutComponent {
    constructor(markInOutService, toastr) {
        this.markInOutService = markInOutService;
        this.toastr = toastr;
        this.isMarked = false;
        this.isPlatform = false;
        this.destroy$ = new Subject();
        let isLoggedIn = JSON.parse(sessionStorage.getItem('currentUser'));
        if (!!isLoggedIn && isLoggedIn.userType && isLoggedIn.userType == 'Platform') {
            this.isPlatform = true;
        }
        else {
            this.isPlatform = false;
        }
        this.employeeId = JSON.parse(sessionStorage.getItem('loginEmployeeId')) || null;
    }
    ngOnInit() {
        if (!this.isPlatform && !!this.employeeId) {
            // Generate current date and time // HH:mm:ss
            let now = encodeURIComponent(moment().format('YYYY-MM-DD HH:mm:ss'));
            this.markInOutService.getAttendanceMarkedDetailsToday(this.employeeId, now).pipe(takeUntil(this.destroy$)).subscribe(response => {
                if (response.status == 200) {
                    if (!response.data.markedIn || (response.data.markedIn && response.data.markedOut)) {
                        this.isMarked = false;
                        this.time = null;
                    }
                    // Based on attendance 
                    if (response.data && !response.data.markedOut && response.data.markedIn) {
                        this.isMarked = true;
                        this.time = response.data.markedIn;
                    }
                }
            }, err => {
                this.isMarked = false;
                CustomErrorToastComponent.showErrorToast(this.toastr, err.error.message);
            });
        }
    }
    markIn() {
        /**
         * *******************************************************************************************
         * NOTE
         * *******************************************************************************************
         * Since, PlatformAdmin is the only user currently using Form Builder, below condition is used
         * to restrict the Mark in click if User is Platform Admin. In future, if any user other than
         * Platform Admin is using Form Builder then change this condition by using something which
         * recognizes Form Builder page and by not user.
         */
        if (!this.isPlatform) {
            // Generate current date and time
            let now = encodeURIComponent(moment().format('YYYY-MM-DD HH:mm:ss'));
            this.markInOutService.markInAttendance(now).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                if (response.status == 200) {
                    this.isMarked = true;
                    this.time = response.data.markedIn;
                    this.toastr.success(response.message, 'Success');
                }
            }, err => {
                CustomErrorToastComponent.showErrorToast(this.toastr, err.error.message);
            });
        }
    }
    markOut() {
        /**
         * *******************************************************************************************
         * NOTE
         * *******************************************************************************************
         * Since, PlatformAdmin is the only user currently using Form Builder, below condition is used
         * to restrict the Mark in/out click if User is Platform Admin. In future, if any user other than
         * Platform Admin is using Form Builder then change this condition by using something which
         * recognizes Form Builder page and by not user.
         */
        if (!this.isPlatform) {
            // Generate current date and time
            let now = encodeURIComponent(moment().format('YYYY-MM-DD HH:mm:ss'));
            // Call the API
            this.markInOutService.markOutAttendance(now).pipe(takeUntil(this.destroy$)).subscribe((response) => {
                if (response.status == 200) {
                    this.isMarked = false;
                    this.time = null;
                    this.toastr.success(response.message, 'Success');
                }
            }, err => {
                CustomErrorToastComponent.showErrorToast(this.toastr, err.error.message);
            });
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
MarkInOutComponent.ɵfac = function MarkInOutComponent_Factory(t) { return new (t || MarkInOutComponent)(i0.ɵɵdirectiveInject(MarkInOutService), i0.ɵɵdirectiveInject(i2.ToastrService)); };
MarkInOutComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MarkInOutComponent, selectors: [["lib-mark-in-out"]], decls: 4, vars: 2, consts: [[1, "mark-in-out-cover"], ["aria-hidden", "true", "pTooltip", "Mark In and Mark Out should be punched only once for marking attendance everyday.", 1, "fa", "fa-info-circle", "mark-in-out-info"], ["class", "mark-in-out-wrapper", 4, "ngIf"], [1, "mark-in-out-wrapper"], [1, "mark-in-left-txt"], [1, "mark-in-title"], [1, "mark-in-right-txt"], ["type", "button", 1, "mark-in-btn", 3, "click"], [1, "pi", "pi-sign-in"], [1, "mark-in-title", 3, "ngClass"], ["class", "mark-in-txt", 4, "ngIf"], [1, "pi", "pi-sign-out"], [1, "mark-in-txt"], [1, "mark-in-time"]], template: function MarkInOutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "span", 1);
        i0.ɵɵtemplate(2, MarkInOutComponent_div_2_Template, 8, 0, "div", 2);
        i0.ɵɵtemplate(3, MarkInOutComponent_div_3_Template, 9, 4, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isMarked == false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMarked == true);
    } }, directives: [i3.Tooltip, i4.NgIf, i4.NgClass], styles: [".mark-in-out-cover[_ngcontent-%COMP%]{background-color:#022e83;padding:4px}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-info[_ngcontent-%COMP%]{color:#fff;padding:6px;float:right;cursor:pointer}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]{background-color:#022e83;display:flex;max-width:100%;padding:8px 10px}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-left-txt[_ngcontent-%COMP%]{flex:1;display:inline-block}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-left-txt[_ngcontent-%COMP%]   .mark-in-title[_ngcontent-%COMP%]{color:#fff;font-size:20px;padding:12px 8px;display:inline-block}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-left-txt[_ngcontent-%COMP%]   .mark-in-btn[_ngcontent-%COMP%]{border:none;margin:4px 16px;border-radius:4px;padding:4px 20px;display:inline-block;text-transform:uppercase;font-weight:700;color:#022e83;text-align:center;font-size:16px}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-left-txt[_ngcontent-%COMP%]   .mark-in-txt[_ngcontent-%COMP%]{color:#fff;display:block;font-size:14px;padding:0 8px}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-right-txt[_ngcontent-%COMP%]{flex:none;display:flex;align-items:center;justify-content:center}.mark-in-out-cover[_ngcontent-%COMP%]   .mark-in-out-wrapper[_ngcontent-%COMP%]   .mark-in-right-txt[_ngcontent-%COMP%]   .mark-in-btn[_ngcontent-%COMP%]{border:none;margin:4px 16px;border-radius:4px;padding:4px 20px;display:inline-block;text-transform:uppercase;font-weight:700;color:#022e83;text-align:center;font-size:16px}.paddingTopBottom0[_ngcontent-%COMP%]{padding-top:0;padding-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MarkInOutComponent, [{
        type: Component,
        args: [{
                selector: 'lib-mark-in-out',
                templateUrl: 'mark-in-out.component.html',
                styleUrls: ['mark-in-out.component.scss']
            }]
    }], function () { return [{ type: MarkInOutService }, { type: i2.ToastrService }]; }, null); })();

class MarkInOutModule {
}
MarkInOutModule.ɵfac = function MarkInOutModule_Factory(t) { return new (t || MarkInOutModule)(); };
MarkInOutModule.ɵmod = i0.ɵɵdefineNgModule({ type: MarkInOutModule });
MarkInOutModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HttpClientModule,
            ToastrModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MarkInOutModule, { declarations: [MarkInOutComponent], imports: [CommonModule,
        HttpClientModule,
        ToastrModule,
        PrimengLibraryModule], exports: [MarkInOutComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MarkInOutModule, [{
        type: NgModule,
        args: [{
                declarations: [MarkInOutComponent],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    ToastrModule,
                    PrimengLibraryModule
                ],
                exports: [MarkInOutComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of mark-in-out
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MarkInOutComponent, MarkInOutModule, MarkInOutService };
//# sourceMappingURL=mark-in-out.js.map
